import {AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {JwtHelperService} from "@auth0/angular-jwt";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import {MatDrawerMode} from "@angular/material/sidenav";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ConfirmationDialog} from "../_shared/dialog/confirmation.dialog";
import {MatDialog} from "@angular/material/dialog";
import {AdminMenuService} from "./admin-menu.service";

@Component({
    selector: 'app-admin-dark-lo',
    templateUrl: './admin-dark.layout.html',
    styleUrls: ['./admin-dark.scss'],
    encapsulation: ViewEncapsulation.None
})

export class AdminDarkLayout implements OnInit, AfterViewChecked, AfterViewInit {

    isSidebarOpen = true;

    navItems = [
        { icon: 'dashboard', label: 'Dashboard', route: '/office/office-dashboard', active: false },
        { icon: 'article', label: 'Certifications', route: '/office/new-certification', active: false },
        { icon: 'event-available', label: 'Trainings', route: '/office/event', active: false },
        { icon: 'group_work', label: 'Associations', route: '/office/association', active: false },
        { icon: 'supervisor_account', label: 'Users', route: '/office/user', active: false },
        { icon: 'chat', label: 'Inbox', route: '/office/inbox', active: false },
        { icon: 'credit_score', label: 'Cyber Combine', route: '/office/scorecard', active: false },
        { icon: 'insert_chart', label: 'Reports', route: '/office/report', active: false },
        { icon: 'settings', label: 'Settings', route: '/office/setting', active: false },
        { icon: 'undo', label: 'To Member Area', route: '/dashboard', active: false },
        { icon: 'logout', label: 'Logout', route: '/office/setting', active: false, isLogout: true },
    ];

    // Tab navigation
    tabs = [
        { label: 'Overview', active: true },
        { label: 'Domains', active: false },
        { label: 'Objectives', active: false },
        { label: 'Conditions', active: false }
    ];

    constructor(
        private cdRef: ChangeDetectorRef,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private adminMenuSvc: AdminMenuService
    ) {

    }
    ngAfterViewChecked(): void {
        this.cdRef.detectChanges();
    }

    ngAfterViewInit(): void {

    }

    ngOnInit(): void {
        let m = this.activatedRoute.snapshot.children[0].routeConfig.path;
        let mx = m.split('/');
        let url = this.activatedRoute.snapshot.url[0].path;
        let route = '/' + url + '/' + mx[0];

        this.navItems.forEach(nav => nav.active = false);
        this.navItems.forEach(nav => {
            if(nav.route == route) {
                nav.active = true;
            }
        });

        this.adminMenuSvc.currentMessage.subscribe(r => {
            if(r) {
                let i = this.navItems.find(ni => ni.route == r.route);
                console.log(i);
                this.onNavItemClick(i);
            }
        })

    }

    onNavItemClick(item: any) {
        this.navItems.forEach(nav => nav.active = false);
        item.active = true;
        if(item.isLogout) {
            const screenWidth = window.innerWidth;
            const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
            const confirm = this.dialog.open(ConfirmationDialog, {
                width: dialogWidth,
                maxWidth: '100%',
                data: {
                    message: "Logout from Cert Wallet account",
                    subMessage: "Are you sure want to logout from your current session?",
                    buttonOkLabel: 'Yes, Logout',
                    buttonCancelLabel: 'Cancel',
                    theme: 'dark'
                }
            });
            confirm.componentInstance.result.subscribe(r => {
                if(r) {
                    localStorage.clear();
                    this.snackBar.open("You have been logged out.", '', {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: ['red-snackbar']})
                    this.router.navigate(['/login']).then();
                }
            })

        } else {
            this.router.navigate([item.route]).then();
        }

    }

    goHome() {
        this.navItems.forEach(nav => nav.active = false);
        this.navItems[0].active = true;
        this.router.navigate(['/office/office-dashboard']).then();
    }

    toggleMenu() {
        this.isSidebarOpen = !this.isSidebarOpen;
        if (!this.isSidebarOpen) {
            setTimeout(() => {
                document.querySelector('.sidebar')?.classList.add('collapsed-done');
                document.querySelector('.main-content-dark')?.classList.add('associations-container-wide');
                document.querySelector('.main-content-dark')?.classList.remove('associations-container');
            }, 50); // wait until transition ends
        } else {
            document.querySelector('.sidebar')?.classList.remove('collapsed-done');
            document.querySelector('.main-content-dark')?.classList.add('associations-container');
            document.querySelector('.main-content-dark')?.classList.remove('associations-container-wide');
        }
    }


}
